
export enum SidbarActionTypes {
    ActivateSidebar = '[Sidebar] Activate Sidebar',
    InactivateSidebar = '[Sidebar] Inactivate Sidebar',
}

export class ActivateSidebar {
    readonly type = SidbarActionTypes.ActivateSidebar;
    constructor(public payload: string) {}
}

export class InactivateSidebar {
    readonly type = SidbarActionTypes.InactivateSidebar;
    constructor(public payload: string) {}
}

export type SidebarActions = 
    ActivateSidebar | 
    InactivateSidebar;